(() => {
  const sorts = ['featured', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending'];
  function mount(root) {
    if (root.dataset.collectionMounted) return;
    root.dataset.collectionMounted = 'true';
    const grid = root.querySelector('.lx-catalogue-grid');
    const cards = [...grid.querySelectorAll('[data-preview-product]')];
    const buttons = [...root.querySelectorAll('[data-collection-filter]')];
    const select = root.querySelector('[data-collection-sort]');
    const count = root.querySelector('[data-collection-count]');
    const allowed = ['all', ...buttons.map(button => button.dataset.collectionFilter)];
    let filter = 'all';
    function apply(save = false) {
      const sorted = [...cards];
      if (select.value.startsWith('price-')) sorted.sort((a, b) => (Number(a.dataset.price) - Number(b.dataset.price)) * (select.value.endsWith('descending') ? -1 : 1));
      if (select.value.startsWith('title-')) sorted.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, 'en', {numeric:true}) * (select.value.endsWith('descending') ? -1 : 1));
      let visible = 0;
      for (const card of sorted) {
        card.hidden = filter !== 'all' && !card.dataset.categories.split(' ').includes(filter);
        if (!card.hidden) visible++;
        grid.append(card);
      }
      for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.collectionFilter === filter));
      count.textContent = visible + ' ' + (visible === 1 ? root.dataset.singular : root.dataset.plural);
      root.querySelector('[data-collection-empty]').hidden = visible !== 0;
      if (save) {
        const url = new URL(location.href);
        if (filter === 'all') url.searchParams.delete('filter'); else url.searchParams.set('filter', filter);
        if (select.value === 'featured') url.searchParams.delete('sort_by'); else url.searchParams.set('sort_by', select.value);
        if (['#pergola-screens', '#slatted-walls', '#pergola-heater'].includes(url.hash)) url.hash = '';
        history.replaceState(null, '', url);
      }
    }
    function readLocation() {
      const params = new URLSearchParams(location.search);
      const hashFilters = {'#pergola-screens':'screens', '#slatted-walls':'walls', '#pergola-heater':'heating'};
      const requested = params.get('filter') || hashFilters[location.hash] || 'all';
      filter = allowed.includes(requested) ? requested : 'all';
      select.value = sorts.includes(params.get('sort_by')) ? params.get('sort_by') : 'featured';
      apply();
    }
    for (const button of buttons) button.addEventListener('click', () => { filter = button.dataset.collectionFilter; apply(true); });
    select.addEventListener('change', () => apply(true));
    window.addEventListener('popstate', readLocation);
    window.addEventListener('hashchange', readLocation);
    root.querySelectorAll('[data-collection-controls]').forEach(control => {control.hidden = false;});
    readLocation();
  }
  const init = () => document.querySelectorAll('[data-lx-collection]').forEach(mount);
  init();
  document.addEventListener('shopify:section:load', init);
})();
